// src/App.js
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from './components/header/header.js';
import Footer from './components/footer/footer.js';
import Home from './pages/homepage/homepage.js';
import AboutUs from './pages/about-us/aboutUs.js';
import Divisions from './pages/divisions/divisions.js';
import Projects from './pages/projects/projects.js';
import ProjectDetail from './components/project-details/ProjectDetail.jsx';
import Careers from './pages/careers/careers.js';
import Testimonial from './pages/testimonials/testimonials.js';
import ContactUs from './pages/contact-us/contactUs.js';
import OurTeam from './pages/team-page/team.js';
import OpeningAnimation from './components/opening-animation/animation.js';
import { ProjectProvider } from './pages/projects/ProjectContext';

function AppContent() {
  const location = useLocation();
  const [animationComplete, setAnimationComplete] = useState(false);

  // Check sessionStorage for animation status
  const alreadyPlayed = sessionStorage.getItem("openingAnimationPlayed");

  const showAnimation = location.pathname === "/" && !animationComplete && !alreadyPlayed;

  return (
    <div style={{ position: "relative" }}>
      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/divisions" element={<Divisions />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/testimonials" element={<Testimonial />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/our-team" element={<OurTeam />} />
      </Routes>
      <Footer />

      {/* Overlay Animation */}
      {showAnimation && (
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 100, overflow: "hidden", touchAction: "none", }}>
          <OpeningAnimation
            onComplete={() => {
              sessionStorage.setItem("openingAnimationPlayed", "true"); // mark it as played
              setAnimationComplete(true); // hide overlay
            }}
          />
        </div>
      )}
    </div>
  );
}

function App() {
  return (
    <ProjectProvider>
      <Router>
        <AppContent />
      </Router>
    </ProjectProvider>
  );
}

export default App;
